import { createClient } from '@supabase/supabase-js';

// These values come from your Supabase project settings
// They are safe to use in the browser (not secret)
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
